<template>
	<div>
		<div class="vl"></div>
			<div class="condition-connection-line font-16 font-gilroy font-weight-500">{{connection_text}}</div>
			<div class="vl"></div>
	</div>
			
	
</template>
<script>
export default {
	props:{
		connection_text:{
			required: true,
			type: String
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/automation/automationSharedView/connectionLine.vue